import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import PsDropdown from '../UI/PsDropdown';
import SlidingPanel from 'react-sliding-side-panel';
import 'react-sliding-side-panel/lib/index.css';
import i18n from 'i18next';
import ProductSystemItemsSingleTable from './ProductSystemItemsSingleTable';
import WizardStandardSubHeader from '../Wizard/WizardStandardSubHeader';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import ProjectSolutionHoleSubform from '../Modals/ProjectSolutionHoleSubform';
import ProjectSolutionCalculationResult from '../Modals/ProjectSolutionCalculationResult';
import ProjectSolutionCalculationInactive from '../Modals/ProjectSolutionCalculationInactive';
import ProjectSolutionCalculationResultHeadline from '../Modals/ProjectSolutionCalculationResultHeadline';
import ProjectSolutionCalculationResultAlert from '../Modals/ProjectSolutionCalculationResultAlert';
import { AlertList } from "react-bs-notifier";
import DocumentationFileTableList from '../Documentations/DocumentationFileTableList';
import LogoDescriptionProductSystem from './LogoDescriptionProductSystem';
import ConsumptionTable from './ConsumptionTable';

const ProductSystemItemsTables = (props) => {

	const [alerts, setAlerts] = useState([]);

  const generate = React.useCallback(
		(type, message)  => {
			setAlerts(alerts => [
				...alerts,
				{
					id: new Date().getTime(),
					type: type,
					headline: ct('wizard.product_system_items.calculator.update_alert.headline'),
					message: message
				}
			]);
		}
	);

	const generateAlert = React.useCallback(
		(type, message)  => {
			setAlerts(alerts => [
				...alerts,
				{
					id: new Date().getTime(),
					type: type,
					headline: ct('wizard.product_system_items.warning.headline'),
					message: message
				}
			]);
		}
	);

	const onDismissed = React.useCallback(alert => {
		setAlerts(alerts => {
			const idx = alerts.indexOf(alert);
			if (idx < 0) return alerts;
			return [...alerts.slice(0, idx), ...alerts.slice(idx + 1)];
		});
	}, []);

  const ct = useCustomTranslation();
  const [resultSchottbelegungAlt, setResultSchottbelegungAlt] = useState({});
  const initalSelectedItems = (props.selectedItems && props.selectedItems.map( x => ( {id: x.product_system_item, amount: x.amount} ))) || [];
	const initialShowModus = props.showModus || (props.modalVersion === true)? 'modalVersion' : 'default'
  const [selectedSystemItems, setSelectedSystemItems] = useState(initalSelectedItems);
	const initialSelectedGap = (selectedSystemItems.count > 0)? selectedSystemItems.map( x => x.gap )[0] : undefined
	const [selectedGap, setSelectedGap] = useState(initialSelectedGap);
  const selectedSystemItemIds = selectedSystemItems.map(x => x.id);
  const holeFormOptions = () => actions.availableHoleForms.map( x => { return { value: x.toLowerCase(), label:  ct('modal.product_solution_meta_data.form.hole_form_' + x + '.label') }} )

  const initalCalculatorData = {
    hole_form: ((props.calculator && props.calculator.hole_form) || holeFormOptions()[0].value),
    hole_diameter: ((props.calculator && props.calculator.hole_diameter) || 0),
    hole_width: ((props.calculator && props.calculator.hole_width) || 0),
    hole_height: ((props.calculator && props.calculator.hole_height) || 0)
  }

  const [calculatorData, setCalculatorData] = useState(initalCalculatorData);
	const [openPanelGapInfo, setOpenPanelGapInfo] = useState(false);
  const [contentProductInfo, setContentProductInfo] = useState("");
  const [contentCountryInfo, setContentCountryInfo] = useState("");

  const [openAccordeoCardProductInfo, setOpenAccordeoCardProductInfo] = useState(false);
  const [openAccordeoCardCountryInfo, setOpenAccordeoCardCountryInfo] = useState(false);
	const [openAccordeoCardDownloadInfo, setOpenAccordeoCardDownloadInfo] = useState(false);
	const [openAccordeoCardSealsInfo, setOpenAccordeoCardSealsInfo] = useState(false);
  const [openAccordeoCardKalkulator, setOpenAccordeoCardKalkulator] = useState(false);
  const [openAccordeoCardConsumption, setOpenAccordeoCardConsumption] = useState(false);


  const [selectedTubeFilter, setSelectedTubeFilter] = useState({penetrations: [], insulations: [], products: []});
  const [selectedCableFilter, setSelectedCableFilter] = useState({penetrations: [], products: []});
  const [selectedTubeMediumFilter, setSelectedTubeMediumFilter] = useState([]);
  const [selectedCableMediumFilter, setSelectedCableMediumFilter] = useState([]);

  const [showCalculatorForm, setShowCalculatorForm] = useState(false);
  const [resultSchottbelegung, setResultSchottbelegung] = useState({});
  const [consumptionData, setConsumptionData] = useState({});

  // Überwache Änderungen an consumptionData
  useEffect(() => {
    console.log("consumption data updated:", consumptionData);
  }, [consumptionData]);

  // Berechne Verbrauch nach dem Laden von selectedSystemItems
  useEffect(() => {
    if (selectedSystemItems && selectedSystemItems.length > 0) {
      calculateConsumption();
    }
  }, [selectedSystemItems]);

  // Berechne Verbrauch bei Änderungen von calculatorData
  useEffect(() => {
    if (selectedSystemItems && selectedSystemItems.length > 0) {
      calculateConsumption();
    }
  }, [calculatorData]);

  const calculateConsumption = (items = selectedSystemItems) => {
    return dispatch(actions.calculateProductSolutionConsumption(items, calculatorData, resultSchottbelegung))
      .then(data => {
        if (data) {
          setConsumptionData(data);
        }
      });
  };

  const showModus = initialShowModus;

  let productSystem = {};

  const selectedSteps = useSelector(state => state.wizard.selectedSteps);
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const [buttons, setButtons] = useState([]);
  const dispatch = useDispatch();

  // for calculator
  const location = actions.locationTypeBySelectedSteps(props.selectedSteps)

  const showCalculatorForm2 = () =>{
    if ((['square', 'circle'].includes(calculatorData.hole_form))) {
			return showCalculatorForm
		} else {
			return true
		}
	}

  const toggleKalkulatorFormDisplay = () => {
		setShowCalculatorForm( !showCalculatorForm2() );
  }

  const fullProductSystemsItems = useSelector(state => actions.getReduxObjects(state.inventory.productSystemItems, selectedSystemItemIds));

  useEffect(() => {
    if (calculatorData.hole_form === 'square' || calculatorData.hole_form === 'circle') {
      setShowCalculatorForm(false);
    } else {
      setShowCalculatorForm(true);
    }
  }, []);

  useEffect(() => {
		const calcSettings = actions.productSystemCalcSettings(productSystem);
		setResultSchottbelegung(actions.calculateSchottbelegung(t, selectedSystemItems, calculatorData, location, calcSettings, fullProductSystemsItems));
    sendCalculatorToModal()
  }, [calculatorData]);

  const sendCalculatorToModal = () => {
    if (props.sendCalculatorToModal !== undefined) {
      props.sendCalculatorToModal()(calculatorData)
    }
  }

  const sendCalculatorResultToModal = (resultSchottbelegung) => {
    if (props.calculator !== undefined) {
      if (props.sendCalculatorResultToModal !== undefined) {

        props.sendCalculatorResultToModal()({
          calculationSchottbelegungSuccess: resultSchottbelegung.calculationSchottbelegungSuccess,
          calculationCoverage: resultSchottbelegung.sum_in_percent,
          calculationStatus: resultSchottbelegung.status
        })
      }
    }
  }

  const calculatorToParent = () => {
    return (hole_form, hole_width, hole_height, hole_diameter) => {
      setCalculatorData( {
        hole_form: hole_form,
        hole_width: hole_width,
        hole_height: hole_height,
        hole_diameter: hole_diameter
       }
      )
    }
  }

  // setzt den Wert für für Gap global, da er als Filter für die zu Auswahl stehenden Elemente in beiden
	// Tabellen gilt. Es dürfen nur Zeilen mit demselben Gap-Wert in eine Durchführung übernommen werden.
	useEffect(() => {
		// selected Items
		var gap_arr = fullProductSystemsItems.map( x => x.gap ) || [];

		var count_different_gaps = productSystemsItems.map( x => x.gap )
    let count_different_gaps_unique = count_different_gaps.filter( (v,i,a) => a.indexOf(v) === i )

    var gap = (gap_arr.length > 0)? gap_arr[0] : undefined;
		var old_gap = selectedGap;
    setSelectedGap(gap);

		// wenn sich die globaleGap ändert und es überhaupt Zeilen mit
		// unterschiedlichen Gaps gibt, soll eine Nachricht angezeigt werden.
    if (old_gap !== gap && gap !== undefined && count_different_gaps_unique.length > 1) {
			showInfoPanelGap();
		}

	}, [selectedSystemItems]);

  useEffect(() => {
    sendItemsToModal()
		const calcSettings = actions.productSystemCalcSettings(productSystem);
    setResultSchottbelegung(actions.calculateSchottbelegung(t, selectedSystemItems, calculatorData, location, calcSettings, fullProductSystemsItems));
  }, [selectedSystemItems]);

	useEffect(() => {
    sendItemsToModal()

    if ((resultSchottbelegung.status !== '') &&
        resultSchottbelegung.status !== 'not_available' &&
        resultSchottbelegung.calculationSchottbelegungSuccess === true ) {
      const message = <ProjectSolutionCalculationResultAlert resSchottbelegung={resultSchottbelegung} />

      switch (resultSchottbelegung.status) {
        case 'greater_than_max':
				  generate('danger', message);
          break;
        case 'between_max_and_krit':
          generate('warning', message);
					break;
        case 'lower_than_krit':
          generate('success', message);
					break;
        default:
          return null;
      }
    }

  }, [resultSchottbelegung]);



  const sendItemsToModal = () => {
    if (props.sendItemsToModal !== undefined) {
      props.sendItemsToModal()(selectedSystemItems);
    }
  }





  const deleteProductSystemItem = (itemId) => {
    setSelectedSystemItems(selectedSystemItems
      .filter(function(value, index, arr) {
        return value.id !== itemId;
    }))
  }

  const substractProductSystemItemParent = (itemId, amount) => {
    if (amount < 1) {
      deleteProductSystemItem(itemId)
    } else {
      const newItems = Array.from(
        new Set([...selectedSystemItems
          .filter(
            function(value, index, arr) {
              return value.id !== itemId;
            }
          ), { id: itemId, amount: amount }]
        )
      );
      
      setSelectedSystemItems(newItems);
      // Berechnung mit den neuen Werten durchführen
      calculateConsumption(newItems);
    }
  }

  const addProductSystemItemParent = () => {
    return (itemId, updatedItem) => {
      const newItems = Array.from(
        new Set([...selectedSystemItems
          .filter(
            function(value, index, arr) {
              return value.id !== itemId;
            }
          ), updatedItem]
        )
      );
      
      setSelectedSystemItems(newItems);
      // Berechnung mit den neuen Werten durchführen
      calculateConsumption(newItems);
    }
  }



  const updateTubeFilter = () => {
    return (x) => {
      setSelectedTubeFilter(x)
    }
  }

  const updateCableFilter = () => {
    return (x) => {
      setSelectedCableFilter(x)
    }
  }

  const updateTubeMediumFilter = () => {
    return (x) => {
      setSelectedTubeMediumFilter(x)
    }
  }

  const updateCableMediumFilter = () => {
    return (x) => {
      console.log('updateCableMediumFilter', x)
      setSelectedCableMediumFilter(x)
    }
  }




  // Die Daten der Tabellenzeilen (ProductSystemItems)

  useEffect(() => { dispatch( actions.fetchProductSystem(props.productSystem)) }, []);

  const thisProductSystem = useSelector(state => {
    return (productSystemId) => actions.getProductSystem(state, productSystemId)
  });
  const loadingProductSystem = useSelector(state => state.inventory.loadingProductSystem );

  useEffect(() => {
    dispatch(actions.fetchProductsolutions(props.selectedSteps)).then((res) => setButtons(res));
  }, []);

  const productSystemsItems = useSelector(state => actions.getReduxObjects(state.inventory.productSystemItems, buttons));

  const infotext = () => {
    const info = productSystem['product_system_infotexts'].find((x)=> ( x['topic'] === 'common_regulations' && x['locale'] === i18n.language));
    return (info !== undefined)? info.text : t('wizard.product_system_items.common_regulations.default_text')
  }

  const docurl = () => {
		const topic = 'website_hensel';
    const urls = productSystem['product_system_urls'] || [];
    const fuerSprache = (locale) => urls.find((x)=> ( x['topic'] === topic && x['locale'] === locale));
    // Deutsch verweist auf die deutsche Seite, jede andere Sprache auf die
    // englische. Fehlt die englische, greift die eigene Sprache, zuletzt der
    // Standardlink. Ohne diese Kette haetten Sprachen ohne eigenen Eintrag
    // (z. B. Spanisch, Slowakisch) gar keinen Link.
    const info = (i18n.language === 'de')
      ? fuerSprache('de')
      : (fuerSprache('en') || fuerSprache(i18n.language));
    return (info !== undefined)? String(info.url).trim() : t('wizard.product_system_items.product_system_urls.default_url')
  }

	const ausschreibungenUrl = () => {
		const topic = 'ausschreibungen';
		const info = productSystem['product_system_urls'] !== undefined && productSystem['product_system_urls'].find((x)=> ( x['topic'] === topic && x['locale'] === i18n.language));
    return (info !== undefined)? info.url : ""
  }

  const infotext_country = () => {
    const topic = 'country_regulations_' + selectedSteps['country'];
    const info = productSystem['product_system_infotexts'].find((x)=> ( x['topic'] === topic && x['locale'] === i18n.language));
    return (info !== undefined)? info.text : t('wizard.product_system_items.country_regulations.default_text')
  }

  const linkToExternalUrl = () => {
    window.open(docurl(), "_blank")
  }

	const linkToAusschreibungenUrl = () => {
    window.open(ausschreibungenUrl(), "_blank")
  }

  const generatePdf = () => {
    if (selectedSystemItems.length > 0) {
      const country = selectedSteps['country'];
      const fwk = selectedSteps['fwk'];
      const installation_location = selectedSteps['location'];
      const execution_type = selectedSteps['executionType'];
      const product_system_id = selectedSteps['productSystem'];
      const product_system_items_with_amount = selectedSystemItems;
      const product_solution_id = props.productSolutionId;
			const hole_diameter = calculatorData.hole_diameter;
			const hole_form = calculatorData.hole_form;
			const hole_height = calculatorData.hole_height;
			const hole_width = calculatorData.hole_width;


			const calculation_schottbelegung_coverage = resultSchottbelegung.sum_in_percent;
			const calculation_schottbelegung_status = resultSchottbelegung.status;
			const calculation_schottbelegung_success = resultSchottbelegung.calculationSchottbelegungSuccess;


      dispatch(actions.downloadProductSolutionPdf(country, fwk, installation_location, execution_type, product_system_id,
				                                          product_system_items_with_amount, product_solution_id,
																									hole_diameter, hole_form, hole_height, hole_width, calculation_schottbelegung_coverage,
			                                            calculation_schottbelegung_status, calculation_schottbelegung_success));
    } else {
			generateAlert('danger', ct('wizard.product_system_items.warning.select_minimum_one_line_to_create_pdf'));
		}
  }

  const generateShortinfoPdf = () => {
    if (selectedSystemItems.length > 0) {
      const product_system_item_ids = selectedSystemItems;
      dispatch(actions.downloadShortinfoPdf(product_system_item_ids));
    }
  }

  const generateIndividuellesTechnischesMerkblattPdf = () => {
    const country = selectedSteps['country'];
    const fwk = selectedSteps['fwk'];
    const installation_location = selectedSteps['location'];
    const execution_type = selectedSteps['executionType'];
    const product_system_id = selectedSteps['productSystem'];
    const filter_cable_penetrations = selectedCableFilter['penetrations'];
    const filter_cable_insulations = selectedCableFilter['insulations'];
    const filter_cable_products = selectedCableFilter['products'];
    const filter_tube_penetrations = selectedTubeFilter['penetrations'];
    const filter_tube_insulations = selectedTubeFilter['insulations']; 
    const filter_tube_products = selectedTubeFilter['products'];
    const filter_cable_medium = selectedCableMediumFilter;
    const filter_tube_medium = selectedTubeMediumFilter;

    dispatch(actions.downloadIndividuellesTechnischesMerkblattPdf(country, fwk, installation_location, execution_type, product_system_id, 
      filter_cable_penetrations, filter_cable_insulations, filter_cable_products, filter_cable_medium, filter_tube_penetrations, filter_tube_insulations, filter_tube_products, filter_tube_medium));
  }

	const showInfoPanelGap = () => {
    setOpenPanelGapInfo(true);
		setTimeout(() => {  setOpenPanelGapInfo(false) }, 3000);
  }

  const onSave = () => {
    const calcSettings = actions.productSystemCalcSettings(productSystem);
    setResultSchottbelegung(actions.calculateSchottbelegung(t, selectedSystemItems, calculatorData, location, calcSettings, fullProductSystemsItems));
    const calcRes = {
      calculationSchottbelegungSuccess: resultSchottbelegung.calculationSchottbelegungSuccess,
      calculationCoverage: resultSchottbelegung.sum_in_percent,
      calculationStatus: resultSchottbelegung.status
    };

    dispatch(props.onSave()(selectedSystemItems, calculatorData, calcRes));
  }

  const toggleAccordeonCardProductInfo = () => {
    setContentProductInfo(infotext);
    setOpenAccordeoCardProductInfo(!openAccordeoCardProductInfo);
  }

  const toggleAccordeonCardCountryInfo = () => {
    setContentCountryInfo(infotext_country);
    setOpenAccordeoCardCountryInfo(!openAccordeoCardCountryInfo);
  }

	const toggleAccordeonCardDownloadInfo = () => {
    setOpenAccordeoCardDownloadInfo(!openAccordeoCardDownloadInfo);
  }

	const toggleAccordeonCardSealsInfo = () => {
    setOpenAccordeoCardSealsInfo(!openAccordeoCardSealsInfo);
  }

  const toggleAccordeonCardKalkulator = () => {
    setOpenAccordeoCardKalkulator(!openAccordeoCardKalkulator);
  }

  const toggleAccordeonCardConsumption = () => {
    setOpenAccordeoCardConsumption(!openAccordeoCardConsumption);
  }

  const certification_title = () => {
    return (productSystemsItems[0] !== undefined) ? productSystemsItems[0].certification_type + " " + productSystemsItems[0].certification_number : ""
  }

  const getLabelGenerateShortInfoPdf = () => {
    if (thisProductSystem(props.productSystem) !== undefined && thisProductSystem(props.productSystem).shortinfo_status === true) {
      if (selectedSystemItems === null || selectedSystemItems === undefined || selectedSystemItems.length === 0) {
        return ct('wizard.product_system_items.dropdown.create_shortinfo_pdf_hint')
      }
      else {
        return ct('wizard.product_system_items.dropdown.create_shortinfo_pdf')
      }
    } else {
      return ct('wizard.product_system_items.dropdown.shortinfo_pdf_not_available')
    }
  }


  const getDisabledStatusGenerateShortInfoPdf = () => {
    if (thisProductSystem(props.productSystem) !== undefined && thisProductSystem(props.productSystem).shortinfo_status === true) {
      if (selectedSystemItems === null || selectedSystemItems === undefined || selectedSystemItems.length === 0) {
        return true
      }
      else {
        return false
      }
    } else {
      return true
    }
  }

  const dropDownItems = () => {
    let items = [];
		items.push({ action: generateShortinfoPdf, text: getLabelGenerateShortInfoPdf(), disabled: getDisabledStatusGenerateShortInfoPdf(), id: "generateShortinfoPdf" });
		items.push({ action: generatePdf,text: ct('wizard.product_system_items.dropdown.create_pdf'),id: "generatePdf" });
		items.push({ action: linkToExternalUrl, text: ct('wizard.product_system_items.dropdown.link_to_external_documentation'), id: "linkToExternalUrl" });
		if (ausschreibungenUrl() !== "") {
		  items.push({ action: linkToAusschreibungenUrl, text: ct('wizard.product_system_items.dropdown.link_to_ausschreibungen'), id: "linkToAusschreibungenUrl" });
		}
    items.push({ action: generateIndividuellesTechnischesMerkblattPdf, text: ct('wizard.product_system_items.dropdown.create_individuelles_technisches_merkblatt_pdf'), id: "generateIndividuellesTechnischesMerkblattPdf" });  
    return items
  }

  const displayCalculatorElements = (resSchottbelegung) => {
    if (productSystem.calculator_status === true) {
      return (showCalculatorForm2() === true)?
      <ProjectSolutionHoleSubform
        calculator={calculatorData}
        showCancelButton={productSystem.calculator_status}
        calculatorToParent={calculatorToParent}
        cancelCalculatorForm={toggleKalkulatorFormDisplay}
        /> : <ProjectSolutionCalculationResult
               resSchottbelegung={resSchottbelegung}
               calculator={calculatorData}
               showCalculatorForm={toggleKalkulatorFormDisplay} />

    } else {
      return (showCalculatorForm2() === true)?
      <ProjectSolutionHoleSubform
        calculator={calculatorData}
        showCancelButton={true}
        calculatorToParent={calculatorToParent}
        cancelCalculatorForm={toggleKalkulatorFormDisplay}
        /> : <ProjectSolutionCalculationInactive
               resSchottbelegung={resSchottbelegung}
               calculator={calculatorData}
               showCalculatorForm={toggleKalkulatorFormDisplay} />
    }
  }

  const displayCalculatorElementsHeadline = (resSchottbelegung) => {

    return (productSystem.calculator_status === true) ?
      <span>
       <span>{ t('wizard.product_system_items.pane.hole_dimensions_and_calculator.title') } </span>
       <ProjectSolutionCalculationResultHeadline
         resSchottbelegung={resSchottbelegung}
         calculator={calculatorData}
         showCalculatorForm={toggleKalkulatorFormDisplay} />
      </span> : <span>{ t('wizard.product_system_items.pane.hole_dimensions.title') }</span>
  }

  if ( !loadingProductSystem || productSystem !== {}) {
    productSystem = thisProductSystem(props.productSystem) || {};

    const calcSettings = actions.productSystemCalcSettings(productSystem);

    const resultSchottbelegung = actions.calculateSchottbelegung(t, selectedSystemItems, calculatorData, location, calcSettings, fullProductSystemsItems);

    if (JSON.stringify(resultSchottbelegungAlt) !== JSON.stringify(resultSchottbelegung)) {
      sendCalculatorResultToModal(resultSchottbelegung);
      setResultSchottbelegungAlt(resultSchottbelegung);
    }

    const productSystemTitle = (productSystem === undefined)? "" : productSystem.title

    const getProductSystemSeals = (seals) => {
      let sealsArray = [];
      if (seals !== undefined) {
        sealsArray = seals.filter((seal) => { return seal.display_pdf === true })
      }
      return sealsArray;
    }

    return (

    <Aux>

    <AlertList
      position={'top-right'}
      alerts={alerts}
      timeout={2000}
      dismissTitle="Begone!"
      onDismiss={onDismissed}
    />


			<SlidingPanel type={'right'} isOpen={openPanelGapInfo} size={90}>
        <div style={{background: "white", padding: "20px"}}>
          <div style={{width: "100%", textAlign: "right"}}>
            <button onClick={()=> setOpenPanelGapInfo(false)} className="btn btn-primary" style={{background: "#fff3df", color: "#6c757d", borderColor: "#ccc"}}>
              Schließen
            </button>
          </div>
          <div>
          Achtung! Es wurden alle Durchführungen mit abweichenden GAPs ausgeblendet, da die GAP-Werte aller Durchführungen identisch sein müssen.
          </div>
        </div>
      </SlidingPanel>

     { (width > 575) ?
       <Aux>

         <div className="row content-list-head">
           <div className="col-10">
             <WizardStandardSubHeader
						   display={productSystemTitle !== undefined && certification_title() !== ""}
               title={productSystemTitle + " | " + certification_title()}
               modalTitle={ t('wizard.steps.product_solution.modaltitle') }
               modalTextToken={ 'wizard.steps.product_solution.infotext' } />
           </div>
           <div style={{float: "right"}}>
             <PsDropdown items={dropDownItems()}>
               <button className="btn btn-primary" type="button" style={{background: "#fff3df", color: "#6c757d", borderColor: "#ccc"}}>
                 { t('wizard.steps.product_solution.button_options') }
                 <i className="material-icons align-top" style={{marginRight: "-10px"}}>more_vert</i>
               </button>
             </PsDropdown>
           </div>
         </div>
       </Aux> :

      <Aux>
        <div className="row">
          <div className="col">
            <WizardStandardSubHeader
						  display={productSystemTitle !== undefined}
              title={productSystemTitle}
              modalTitle={ t('wizard.steps.product_solution.modaltitle') }
              modalTextToken={ 'wizard.steps.product_solution.infotext' } />
          </div>
          <div style={{float: "right"}}>
            <PsDropdown items={dropDownItems()}>
              <button className="btn btn-primary" type="button" style={{background: "#fff3df", color: "#6c757d", borderColor: "#ccc"}}>
                <i className="material-icons align-top" style={{marginLeft: "-10px", marginRight: "-10px"}}>more_vert</i>
              </button>
            </PsDropdown>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <h3 style={{fontSize: "1.0rem"}}>{certification_title()}</h3>
          </div>
        </div>
      </Aux>
     }

     <div className="row ml-0">
       <div className="col">
        <ProductSystemItemsSingleTable
          headline={ t('wizard.steps.product_solution.table_tubes.title') }
          tableType="tube"
          updateFilter={updateTubeFilter}
          updateMediumFilter={updateTubeMediumFilter}
					showModus={showModus}
					globalGap={selectedGap}
          selectedItems={selectedSystemItems}
          selectedSteps={props.selectedSteps}
          substractProductSystemItemParent={substractProductSystemItemParent}
          availableMediumTypes={actions.availableMediumTypesTubes}
          addProductSystemItemParent={addProductSystemItemParent}
          />
        <ProductSystemItemsSingleTable
          headline={ t('wizard.steps.product_solution.table_cables.title') }
          tableType="cable"
          updateFilter={updateCableFilter}
          updateMediumFilter={updateCableMediumFilter}
					showModus={showModus}
					globalGap={selectedGap}
          selectedItems={selectedSystemItems}
          selectedSteps={props.selectedSteps}
          substractProductSystemItemParent={substractProductSystemItemParent}
          availableMediumTypes={actions.availableMediumTypesCables}
          addProductSystemItemParent={addProductSystemItemParent}
          />
        </div>
      </div>

      <div className="paccordeon" id="accordionExample">
        <div className="card">
          <div className="card-header" id="headingKalkulator" onClick={toggleAccordeonCardKalkulator} style={{backgroundColor: "#ed886d", color: "black", padding: "0"}}>
              <button className={(openAccordeoCardKalkulator === true)? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"}   type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
                { displayCalculatorElementsHeadline(resultSchottbelegung) }
              </button>
              <i className="material-icons" style={{padding: "7px", float: "right"}}>{(openAccordeoCardKalkulator === true)? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
          </div>
          <div id="collapseOne" className={(openAccordeoCardKalkulator === true)? "collapse show" : "collapse"}>
            <div className="card-body" style={{padding: "0.5rem"}}>
              { displayCalculatorElements(resultSchottbelegung) }
            </div>
          </div>
        </div>
      </div>

      <div className="card-list">
        <div className="card-list-body filter-list-1599070578586">
          <div className="wizzard-two">
            { (props.modalVersion !== true)? <button className="btn btn-light solution-right" onClick={onSave}>{ t('wizard.product_system_items.button.save') }</button> : null}
          </div>
        </div>
      </div>


      <div className="paccordeon" id="accordionExample">
        <div className="card">
          <div className="card-header" id="headingConsumption" onClick={toggleAccordeonCardConsumption} style={{backgroundColor: "#fedd66", color: "black", padding: "0"}}>
              <button className={(openAccordeoCardConsumption === true)? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"} type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
                { t('wizard.product_system_items.pane.calculate_consumption.title') }
              </button>
              <i className="material-icons" style={{padding: "7px", float: "right"}}>{(openAccordeoCardConsumption === true)? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
          </div>
          <div id="collapseConsumption" className={(openAccordeoCardConsumption === true)? "collapse show" : "collapse"}>
            <div className="card-body">
              <ConsumptionTable consumptionData={consumptionData} />
            </div>
          </div>
        </div>
      </div>

      { (width > 575) ?

      <div className="paccordeon" id="accordionExample">

        <div className="card">
          <div className="card-header" id="headingOne" onClick={toggleAccordeonCardProductInfo} style={{backgroundColor: "#fedd66", color: "black", padding: "0"}}>
              <button className={(openAccordeoCardProductInfo === true)? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"}   type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
                { t('wizard.product_system_items.pane.product_info.title') }
              </button>
              <i className="material-icons" style={{padding: "7px", float: "right"}}>{(openAccordeoCardProductInfo === true)? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
          </div>
          <div id="collapseOne" className={(openAccordeoCardProductInfo === true)? "collapse show" : "collapse"}>
            <div className="card-body" dangerouslySetInnerHTML={{
                  __html: contentProductInfo
                  }}/>
            </div>
          </div>

          <div className="card">
            <div className="card-header" id="headingOne" onClick={toggleAccordeonCardCountryInfo} style={{backgroundColor: "#fedd66", color: "black", padding: "0"}}>
                <button className={(openAccordeoCardCountryInfo === true)? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"}   type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
                  { t('wizard.product_system_items.pane.country_info.title') }
                </button>
                <i className="material-icons" style={{padding: "7px", float: "right"}}>{(openAccordeoCardCountryInfo === true)? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
            </div>
            <div id="collapseOne" className={(openAccordeoCardCountryInfo === true)? "collapse show" : "collapse"}>
            <div className="card-body" dangerouslySetInnerHTML={{
                  __html: contentCountryInfo
                  }}/>
            </div>
          </div>

					<div className="card">
            <div className="card-header" id="headingOne" onClick={toggleAccordeonCardDownloadInfo} style={{backgroundColor: "#fedd66", color: "black", padding: "0"}}>
                <button className={(openAccordeoCardDownloadInfo === true)? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"}   type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
                  { t('wizard.product_system_items.pane.document_downloads.title') }
                </button>
                <i className="material-icons" style={{padding: "7px", float: "right"}}>{(openAccordeoCardDownloadInfo === true)? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
            </div>
            <div id="collapseOne" className={(openAccordeoCardDownloadInfo === true)? "collapse show" : "collapse"}>
            <div className="card-body">
						  <DocumentationFileTableList productSystemId={productSystem.id} />
						</div>
            </div>
          </div>

					<div className="card">
            <div className="card-header" id="headingOne" onClick={toggleAccordeonCardSealsInfo} style={{backgroundColor: "#fedd66", color: "black", padding: "0"}}>
                <button className={(openAccordeoCardSealsInfo === true)? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"}   type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
                  { t('wizard.product_system_items.pane.seals.title') }
                </button>
                <i className="material-icons" style={{padding: "7px", float: "right"}}>{(openAccordeoCardSealsInfo === true)? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
            </div>
            <div id="collapseOne" className={(openAccordeoCardSealsInfo === true)? "collapse show" : "collapse"}>
            <div className="card-body">
						  <LogoDescriptionProductSystem logos={ getProductSystemSeals(productSystem.seals) } />
						</div>
            </div>
          </div>



        </div> : null
      }

    </Aux>
  )
  } else {
    return null;
  }

};

export default ProductSystemItemsTables;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemItemsTables.js